export default "__VITE_PUBLIC_ASSET__77dc971e__"